import script from "./Photo.vue?vue&type=script&lang=ts&setup=true"
export * from "./Photo.vue?vue&type=script&lang=ts&setup=true"

import "./Photo.vue?vue&type=style&index=0&id=4cb9644d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cb9644d"]])

export default __exports__